module.exports = __webpack_public_path__ + "static/natwest-card-e8f9aa08afe838281dccfd02aee9804f.png";